import { render, staticRenderFns } from "./Divisive.vue?vue&type=template&id=3a22a964"
import script from "./Divisive.vue?vue&type=script&lang=js"
export * from "./Divisive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports